import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import Icon from '../Icon';
import PopOut from './PopOut';
import Form from '../../modules/Form';

const Select = ({
  className,
  disabled,
  id,
  info,
  label,
  options,
  value,
  isInvalid,
  invalidMessage,
  ...props
}) => {
  const classes = ClassNames({
    [className]: className,
    Form_control: true,
    'Form_control-noLabel': !label,
  });

  const inputRef = useRef();
  const inputDisabledMutationObserverRef = useRef();

  function onBlur(event) {
    Form.onInputBlur(event);
    if (props.onBlur) props.onBlur(event);
  }

  function onChange(event) {
    Form.onInputChange(event);
    if (props.onChange) props.onChange(event);
  }

  function onFocus(event) {
    Form.onInputFocus(event);
    if (props.onFocus) props.onFocus(event);
  }

  function onInput(event) {
    Form.onInputChange(event);
  }

  function onInvalid(event) {
    Form.onInputInvalid(event);
  }

  useEffect(() => {
    inputDisabledMutationObserverRef.current
      = Form.createInputDisabledMutationObserver(inputRef.current);

    return () => inputDisabledMutationObserverRef.current.disconnect();
  }, []);

  return (
    <div className={classes} data-form="control">
      <select
        className="Form_select"
        data-form="input"
        disabled={disabled}
        id={id}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onInput={onInput}
        onInvalid={onInvalid}
        ref={inputRef}
        type="input"
        value={value}
      >
        {options.map(option => (
          <option value={option.value} key={option.value}>{option.label}</option>
        ))}
      </select>
      <Icon name="Arrow" className="Form_selectArrowIcon" />
      {label &&
        <label className="Form_controlLabel" htmlFor={id}>{label}</label>
      }
      {info &&
        <PopOut info={info}>
          <button type="button" className="Form_popOutHit Form_popOutHit-right">i</button>
        </PopOut>
      }
      { isInvalid &&
      <p className="Form_validation" >{invalidMessage}</p>
      }
    </div>
  );
};

Select.defaultProps = {
  disabled: false,
  options: [],
};

Select.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  info: PropTypes.string,
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
  value: PropTypes.string,
  isInvalid: PropTypes.bool,
  invalidMessage: PropTypes.string,
};

export default Select;
